import commonApi from "./CommonApi.js";

export default {
	getAll: async (parameter) => {
		return await commonApi().get("/v1/admin/countryNotificationLanguages/getAll", { params: parameter })
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getLanguagesByCountryId: async (parameter) => {
		return await commonApi().get("/v1/countryNotificationLanguages/getLanguagesByCountryId", { params: parameter })
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	edit: async (viewModel) => {
		return await commonApi().put('/v1/admin/countryNotificationLanguages', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
}